import httpClient from '../../../shared/services/httpClient';
import { format } from 'date-fns';

const reportsApi = {

    // Issue Report
// // Issue Report
// getAttendanceReport: (params = {}) => {
//   // Get current date in YYYY-MM-DD format
//   const today = new Date().toISOString().split('T')[0];
  
//   // Set default params
//   const defaultParams = {
//     start_date: today,
//     end_date: today,
//     ...params  // This will override defaults if params are provided
//   };
  
//   return httpClient.get('/attendance/report', { params: defaultParams });
// },



// Issue Report
getAttendanceReport: (params = {}) => {
  const today = format(new Date(), 'yyyy-MM-dd');
  
  const defaultParams = {
    start_date: today,
    end_date: today,
    ...params
  };
  
  return httpClient.get('/attendance/report', { params: defaultParams });
},
  // Issue Report
  getIssueReport: (params = {}) => {
   var response= httpClient.get('/stock/reports/issue', { params });
   //console.log(response);
     return response;
  },

  // Stock Availability Report
  getStockReport: (params = {}) => {
    return httpClient.get('/stock/reports/stock', { params });
  },

  // Low Stock Report
  getLowStockReport: (params = {}) => {
    return httpClient.get('/stock/reports/low_stock', { params });
  },

  // Expiry Report
  getExpiryReport: (params = {}) => {
    return httpClient.get('/stock/reports/expiry', { params });
  },

  // Movement Summary Report
  getMovementSummary: (params = {}) => {
    return httpClient.get('/stock/reports/movement_summary', { params });
  },

  // Top Consumed Medicines Report
  getTopConsumed: (params = {}) => {
    return httpClient.get('/stock/reports/top_consumed', { params });
  }
};

export default reportsApi;